import { defineProperty as _defineProperty, inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reactifiPageTitle } from '../metatags/title.js';
import { Toolbar } from './Toolbar.js';
import { PageBanner } from './PageBanner.js';
import { PageHeaderButtonPropType, PageHeaderButton } from './PageHeaderButton.js';
import { PageHeaderTabs } from './PageHeaderTabs.js';
import { FAIcon } from './fa-icon/component.js';
import { formatClassName as _formatClassName } from '../utils/formatClassName.js';
/** renders the standard page header used in Foundry */

var PageHeader = /*#__PURE__*/function (_Component) {
  function PageHeader() {
    var _this;

    _classCallCheck(this, PageHeader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _callSuper(this, PageHeader, [].concat(args));
    /**
     * if overrideTitle is passed it will override HTML <title> tag.
     * if not passed it will take pageTitle as HTML <title> tag.
     */

    _defineProperty(_this, "setDocumentTitle", function (pageTitle, overrideTitle) {
      if (overrideTitle) {
        reactifiPageTitle(overrideTitle, '%s');
      } else {
        reactifiPageTitle(pageTitle);
      }
    });

    _defineProperty(_this, "onDefaultBack", function (e) {
      e.preventDefault();
      var backButton = _this.props.backButton;

      if (backButton === true) {
        window.location.href = '#/';
      } else {
        backButton();
      }
    });

    _defineProperty(_this, "renderBackButton", function () {
      var backButton = _this.props.backButton;

      if (!backButton) {
        return null;
      }

      return /*#__PURE__*/React.createElement("a", {
        onClick: function onClick(e) {
          return _this.onDefaultBack(e);
        },
        className: "header-back zmdi zmdi-hc-lg zmdi-arrow-back",
        href: "#",
        "aria-label": "back",
        "data-back-arrow": true
      });
    });

    _defineProperty(_this, "renderHeaderIcon", function () {
      var icon = _this.props.icon;

      if (!icon) {
        return null;
      }

      return /*#__PURE__*/React.createElement(FAIcon, {
        icon: icon,
        additionalClasses: "header-icon"
      });
    });

    _defineProperty(_this, "renderHeaderButton", function () {
      var actionButton = _this.props.actionButton;

      if (!actionButton) {
        return null;
      }

      return /*#__PURE__*/React.createElement(PageHeaderButton, {
        actionButton: actionButton
      });
    });

    _defineProperty(_this, "renderHeaderBars", function () {
      var _this$props = _this.props,
          banner = _this$props.banner,
          children = _this$props.children,
          headerTabs = _this$props.headerTabs,
          toolbar = _this$props.toolbar;
      return /*#__PURE__*/React.createElement("div", {
        className: "header-bars"
      }, headerTabs && /*#__PURE__*/React.createElement(PageHeaderTabs, {
        headerTabs: headerTabs
      }), toolbar, banner, children);
    });

    return _this;
  }

  _inherits(PageHeader, _Component);

  return _createClass(PageHeader, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var pageTitle = prevProps.title,
          overrideTitle = prevProps.overrideTitle;

      if (this.props.title !== pageTitle || this.props.overrideTitle !== overrideTitle) {
        this.setDocumentTitle(this.props.title, this.props.overrideTitle);
      }
    }
  }, {
    key: "headerBarClasses",
    get: function get() {
      var _this$props2 = this.props,
          banner = _this$props2.banner,
          headerTabs = _this$props2.headerTabs,
          toolbar = _this$props2.toolbar;
      return _formatClassName({
        toolbar: toolbar,
        banner: banner,
        'header-tabs': headerTabs
      });
    }
  }, {
    key: "headingClassName",
    get: function get() {
      var headingClass = this.props.headingClass;
      return _formatClassName(['page-heading', headingClass, this.headerBarClasses]);
    }
  }, {
    key: "headerBarClassName",
    get: function get() {
      return _formatClassName(['header-title-bar', this.headerBarClasses]);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: this.headingClassName
      }, /*#__PURE__*/React.createElement("div", {
        className: this.headerBarClassName
      }, this.renderBackButton(), /*#__PURE__*/React.createElement("h1", {
        className: "header-title"
      }, this.renderHeaderIcon(), this.props.title), this.renderHeaderButton()), this.renderHeaderBars());
    }
  }]);
}(Component);

_defineProperty(PageHeader, "propTypes", {
  /** configures the action buttons rendered in the header */
  actionButton: PageHeaderButtonPropType,

  /** renders a back button - true for default behavior
   *  or a function to be called instead */
  backButton: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),

  /** renders a PageBanner */
  banner: PropTypes.instanceOf(PageBanner),

  /** renders and child elements at the bottom of the header */
  children: PropTypes.any,

  /** renders a tabs right underneath the title */
  headerTabs: PropTypes.element,

  /** adds a class to the wrapper */
  headingClass: PropTypes.string,

  /** adds a zmdi icon in front of the page title */
  icon: PropTypes.string,

  /** overrides the value set for the document window title */
  overrideTitle: PropTypes.string,

  /** title displayed at the top of the page and sets the
   *  document window title */
  title: PropTypes.string,

  /** renders a toolbar */
  toolbar: PropTypes.instanceOf(Toolbar)
});

_defineProperty(PageHeader, "defaultProps", {
  backButton: false,
  headingClass: 'row'
});

PageHeader.displayName = "PageHeader";
export { PageHeader };